import { ReactNode } from 'react';

import { cn, ConditionalRender } from '@crossnokaye/ux-common';

import { LabelConfigVariant } from '@repo/sdk/models/components';

import { Stack } from '@/ux-common/components/stack/stack';

import { bannerVariantBackgroundClassName, bannerVariantTextClassName } from './animatics.helpers';

type AnimaticBannerProps = {
  children?: ReactNode;
  className?: string;
  label: string;
  subLabel?: string;
  variant?: LabelConfigVariant;
};

export const AnimaticBanner = ({
  children,
  className,
  label,
  subLabel,
  variant,
}: AnimaticBannerProps): ReactNode => {
  const labelClassName = bannerVariantTextClassName(variant);
  const backgroundClassName = bannerVariantBackgroundClassName(variant);
  return (
    <div className={cn('relative w-full', className)}>
      {children}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none">
        <Stack
          className={cn('stack-none w-full text-center py-1', backgroundClassName, labelClassName)}
        >
          <span className="text-xl font-bold">{label}</span>
          <ConditionalRender condition={!!subLabel}>
            <span className="text-sm">{subLabel}</span>
          </ConditionalRender>
        </Stack>
      </div>
    </div>
  );
};
